/* Barra de oferta por pasos — Naysee Parfum.
   Quién actualiza cada barra (una sola vez por cambio del carrito):
   - La barra del carrito lateral viaja dentro del carrito: la actualiza quien redibuja el carrito
     (assets/cart.js y assets/cart-drawer.js). Aquí no se vuelve a pedir.
   - Las demás barras (página «Elige tu 2º perfume», página /cart) se piden aquí con la sección naysee-progreso.
   Cada vez que aparece una barra nueva en la página (venga de donde venga) se hace, antes de que se pinte:
   - el ajuste del tamaño de letra para que la frase y el mensaje quepan en un renglón, y
   - la animación de un paso SOLO si ese paso se acaba de lograr por primera vez. */
(function () {
  if (window.NayseeProgreso) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CAMBIA_CARRITO = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null, pidiendo = false, otraVez = false;

  // Pasos logrados la última vez, por lugar (carrito lateral o página). null = todavía no se ha visto esa barra.
  var logrados = { carrito: null, pagina: null };
  function lugarDe(el) { return el.closest('cart-drawer') ? 'carrito' : 'pagina'; }
  function pasosDe(el) {
    return Array.prototype.map.call(el.querySelectorAll('[data-paso].is-ok'), function (p) { return p.dataset.paso; });
  }

  // ----- Ajuste del tamaño de letra (se calcula una vez por texto y ancho, y se aplica antes de pintar) -----
  var tamanos = {};
  function ajustarTexto(el) {
    if (!el.clientWidth) return;
    var clave = el.className + '|' + el.clientWidth + '|' + el.textContent;
    if (tamanos[clave]) { el.style.fontSize = tamanos[clave]; return; }
    el.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(el).fontSize) || 14;
    var base = fs;
    var vueltas = 0;
    while (el.scrollWidth > el.clientWidth + 1 && fs > 11 && vueltas++ < 20) {
      fs -= 0.5;
      el.style.fontSize = fs + 'px';
    }
    tamanos[clave] = fs === base ? '' : fs + 'px';
  }

  // ----- Animación: solo pasos recién logrados -----
  var EMOJIS = { '1': ['🎁', '✨'], '2': ['🚚', '🎉', '✨'], '3': ['🥳', '🎉', '✨'] };
  function festejar(paso) {
    paso.classList.add('is-nuevo');
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var lista = EMOJIS[paso.dataset.paso] || ['🎉', '✨'];
    var ico = paso.querySelector('.nsp-prog__ico') || paso;
    lista.forEach(function (emoji, i) {
      var e = document.createElement('span');
      e.className = 'nsp-prog__fiesta';
      e.setAttribute('aria-hidden', 'true');
      e.textContent = emoji;
      e.style.setProperty('--dx', (i - (lista.length - 1) / 2) * 16 + 'px');
      e.style.animationDelay = i * 90 + 'ms';
      ico.appendChild(e);
      setTimeout(function () { e.remove(); }, 1500);
    });
    // Se quita la marca al terminar, para que un redibujo posterior no la repita
    setTimeout(function () { paso.classList.remove('is-nuevo'); }, 700);
  }

  function procesarBarra(barra) {
    barra.querySelectorAll('.nsp-prog__titulo, .nsp-prog__msg').forEach(ajustarTexto);
    var lugar = lugarDe(barra);
    var ahora = pasosDe(barra);
    var antes = logrados[lugar];
    if (antes) {
      barra.querySelectorAll('[data-paso].is-ok').forEach(function (p) {
        if (antes.indexOf(p.dataset.paso) === -1) festejar(p);
      });
    }
    logrados[lugar] = ahora;
  }

  // Cualquier cambio dentro de una barra (barra nueva, una parte nueva o un paso que se marca) se procesa en el
  // mismo momento, antes de que el navegador pinte: así las letras nunca se ven primero grandes y luego chicas.
  new MutationObserver(function (muts) {
    var barras = [];
    function agregar(b) { if (b && barras.indexOf(b) === -1) barras.push(b); }
    muts.forEach(function (m) {
      if (m.type === 'attributes') {
        if (m.target.matches && m.target.matches('[data-paso]') && !m.target.classList.contains('is-nuevo')) agregar(m.target.closest('[data-naysee-progreso]'));
        return;
      }
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1 || n.classList.contains('nsp-prog__fiesta')) return;
        if (n.matches('[data-naysee-progreso]')) agregar(n);
        else if (n.closest && n.closest('[data-naysee-progreso]')) agregar(n.closest('[data-naysee-progreso]'));
        else if (n.querySelectorAll) n.querySelectorAll('[data-naysee-progreso]').forEach(agregar);
      });
    });
    barras.forEach(procesarBarra);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  // ----- Barras fuera del carrito lateral (página «Elige tu 2º perfume», página /cart) -----
  function barrasDePagina() {
    return Array.prototype.filter.call(document.querySelectorAll('[data-naysee-progreso]'), function (b) { return !b.closest('cart-drawer'); });
  }

  function aplicar(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('[data-naysee-progreso]');
    if (!nuevo) return;
    barrasDePagina().forEach(function (el) {
      if (el.outerHTML === nuevo.outerHTML) return; // no cambió: no se toca
      el.replaceWith(nuevo.cloneNode(true));
    });
    // Aviso para la página «Elige tu 2º perfume» (títulos y botón de pagar)
    document.dispatchEvent(new CustomEvent('naysee:oferta'));
  }

  function pedir() {
    if (pidiendo) { otraVez = true; return; }
    pidiendo = true;
    _fetch(root + '?section_id=naysee-progreso', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(aplicar)
      .catch(function () {})
      .then(function () {
        pidiendo = false;
        if (otraVez) { otraVez = false; pedir(); }
      });
  }

  // Solo pide la barra si hay alguna fuera del carrito lateral; la del carrito ya viene con el carrito.
  function refresh() {
    if (!barrasDePagina().length) {
      document.dispatchEvent(new CustomEvent('naysee:oferta'));
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(pedir, 150);
  }

  // Las peticiones del tema que ya piden «sections» (carrito, botón Agregar) redibujan el carrito solas.
  function pideSecciones(init) {
    var body = init && init.body;
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf('"sections"') !== -1 || /(^|&)sections=/.test(body);
    if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
    return false;
  }

  // Si el carrito cambió desde otro lado (kit, 2º perfume, botones propios), el carrito lateral se actualiza
  // (una sola petición, solo lo que cambió) para que sus renglones no se queden viejos.
  function carritoCambio(completo) {
    if (completo) {
      var items = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
    }
    refresh();
  }

  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (CAMBIA_CARRITO.test(url)) {
      var completo = !pideSecciones(init);
      p.then(function (r) { if (r && r.ok) carritoCambio(completo); }).catch(function () {});
    }
    return p;
  };

  function ajustarTodo() {
    document.querySelectorAll('[data-naysee-progreso] .nsp-prog__titulo, [data-naysee-progreso] .nsp-prog__msg').forEach(ajustarTexto);
  }

  window.NayseeProgreso = { refresh: refresh, ajustar: ajustarTodo };

  function iniciar() {
    // Estado inicial sin animación
    document.querySelectorAll('[data-naysee-progreso]').forEach(function (b) {
      logrados[lugarDe(b)] = pasosDe(b);
    });
    ajustarTodo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  var timerResize;
  window.addEventListener('resize', function () { clearTimeout(timerResize); timerResize = setTimeout(ajustarTodo, 100); });
  // Al abrir el carrito lateral el ancho ya es el real: se revisa el ajuste
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) setTimeout(ajustarTodo, 50);
  });

  // Al volver con el botón «atrás», el carrito pudo cambiar en otra página.
  window.addEventListener('pageshow', function (e) { if (e.persisted) carritoCambio(true); });
})();
